// permalink for the source: https://github.com/Accedo-Products/one-error-specification/blob/818e3768b638fcdb42724a6d5ffd6eb391cf0f0f/errors.yml
import { IconNames } from '@dynamic/ui';

export const errorSpecVersion = '0.0.14';

export enum Errors {
  // Category: Unknown
  UNKNOWN = 'UNKNOWN',

  // Category: Purchase - Offers Loading (01)
  PURCHASE_OFFERS_LOADING_UNKNOWN = 'PURCHASE_OFFERS_LOADING_UNKNOWN',
  PURCHASE_OFFERS_LOADING_IAP_CONFIG_UNAVAILABLE = 'PURCHASE_OFFERS_LOADING_IAP_CONFIG_UNAVAILABLE',
  PURCHASE_OFFERS_LOADING_IAP_PLUGIN_UNAVAILABLE = 'PURCHASE_OFFERS_LOADING_IAP_PLUGIN_UNAVAILABLE',
  PURCHASE_OFFERS_LOADING_USER_NOT_LOGGED_IN = 'PURCHASE_OFFERS_LOADING_USER_NOT_LOGGED_IN',
  PURCHASE_OFFERS_LOADING_PRODUCT_CATALOG_UNAVAILABLE = 'PURCHASE_OFFERS_LOADING_PRODUCT_CATALOG_UNAVAILABLE',
  PURCHASE_OFFERS_LOADING_PROFILE_ENTITLEMENTS_UNAVAILABLE = 'PURCHASE_OFFERS_LOADING_PROFILE_ENTITLEMENTS_UNAVAILABLE',
  PURCHASE_OFFERS_LOADING_UNKNOWN_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_UNKNOWN_EXISTING_SUBSCRIPTION',
  PURCHASE_OFFERS_LOADING_SKU_UNAVAILABLE = 'PURCHASE_OFFERS_LOADING_SKU_UNAVAILABLE',
  PURCHASE_OFFERS_LOADING_ENTITLEMENT_MISSING_AND_DEVICE_RESTRICTED = 'PURCHASE_OFFERS_LOADING_ENTITLEMENT_MISSING_AND_DEVICE_RESTRICTED',
  PURCHASE_OFFERS_LOADING_CREDIT_CARD_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_CREDIT_CARD_EXISTING_SUBSCRIPTION',
  PURCHASE_OFFERS_LOADING_IAP_AMAZON_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_IAP_AMAZON_EXISTING_SUBSCRIPTION',
  PURCHASE_OFFERS_LOADING_IAP_APPLE_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_IAP_APPLE_EXISTING_SUBSCRIPTION',
  PURCHASE_OFFERS_LOADING_IAP_GOOGLE_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_IAP_GOOGLE_EXISTING_SUBSCRIPTION',
  PURCHASE_OFFERS_LOADING_IAP_ROKU_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_IAP_ROKU_EXISTING_SUBSCRIPTION',
  PURCHASE_OFFERS_LOADING_PAYPAL_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_PAYPAL_EXISTING_SUBSCRIPTION',
  PURCHASE_OFFERS_LOADING_NO_OFFERS_TO_PURCHASE = 'PURCHASE_OFFERS_LOADING_NO_OFFERS_TO_PURCHASE',
  PURCHASE_OFFERS_LOADING_IAP_VIZIO_EXISTING_SUBSCRIPTION = 'PURCHASE_OFFERS_LOADING_IAP_VIZIO_EXISTING_SUBSCRIPTION',

  // Category: Purchase - Validation (02)
  PURCHASE_VALIDATION_UNKNOWN = 'PURCHASE_VALIDATION_UNKNOWN',
  PURCHASE_VALIDATION_IAP_PLUGIN_UNAVAILABLE = 'PURCHASE_VALIDATION_IAP_PLUGIN_UNAVAILABLE',
  PURCHASE_VALIDATION_STORE_ISSUE = 'PURCHASE_VALIDATION_STORE_ISSUE',
  PURCHASE_VALIDATION_UNKNOWN_EXISTING_SUBSCRIPTION = 'PURCHASE_VALIDATION_UNKNOWN_EXISTING_SUBSCRIPTION',
  PURCHASE_VALIDATION_ALREADY_IN_PROGRESS = 'PURCHASE_VALIDATION_ALREADY_IN_PROGRESS',
  PURCHASE_VALIDATION_STORE_ITEM_UNAVAILABLE = 'PURCHASE_VALIDATION_STORE_ITEM_UNAVAILABLE',
  PURCHASE_VALIDATION_RECEIPT_UNAVAILABLE = 'PURCHASE_VALIDATION_RECEIPT_UNAVAILABLE',
  PURCHASE_VALIDATION_SKU_UNAVAILABLE = 'PURCHASE_VALIDATION_SKU_UNAVAILABLE',
  PURCHASE_VALIDATION_ITEM_NOT_OWNED = 'PURCHASE_VALIDATION_ITEM_NOT_OWNED',
  PURCHASE_VALIDATION_ITEM_ALREADY_OWNED = 'PURCHASE_VALIDATION_ITEM_ALREADY_OWNED',
  PURCHASE_VALIDATION_USER_CANCELED = 'PURCHASE_VALIDATION_USER_CANCELED',
  PURCHASE_VALIDATION_BILLING_CLIENT_NOT_READY = 'PURCHASE_VALIDATION_BILLING_CLIENT_NOT_READY',
  PURCHASE_VALIDATION_FAILED = 'PURCHASE_VALIDATION_FAILED',
  PURCHASE_VALIDATION_USER_NOT_LOGGED_IN = 'PURCHASE_VALIDATION_USER_NOT_LOGGED_IN',
  PURCHASE_VALIDATION_PROFILE_ENTITLEMENTS_UNAVAILABLE = 'PURCHASE_VALIDATION_PROFILE_ENTITLEMENTS_UNAVAILABLE',
  PURCHASE_UNKNOWN_EXISTING_SUBSCRIPTION = 'PURCHASE_UNKNOWN_EXISTING_SUBSCRIPTION',
  PURCHASE_VALIDATION_CONFLICT = 'PURCHASE_VALIDATION_CONFLICT',
  PURCHASE_VALIDATION_SERVER_FAILURE = 'PURCHASE_VALIDATION_SERVER_FAILURE',
  PURCHASE_NETWORK_ERROR = 'PURCHASE_NETWORK_ERROR',
  PURCHASE_SERVICE_UNAVAILABLE = 'PURCHASE_SERVICE_UNAVAILABLE',
  PURCHASE_BILLING_UNAVAILABLE = 'PURCHASE_BILLING_UNAVAILABLE',
  PURCHASE_FEATURE_NOT_SUPPORTED = 'PURCHASE_FEATURE_NOT_SUPPORTED',
  PURCHASE_OPERATION_NOT_SUPPORTED = 'PURCHASE_OPERATION_NOT_SUPPORTED',
  PURCHASE_PAYPAL_USER_CANCELED = 'PURCHASE_PAYPAL_USER_CANCELED',
  PURCHASE_PAYPAL_UNKNOWN = 'PURCHASE_PAYPAL_UNKNOWN',
  PURCHASE_USER_INELIGIBLE_TO_PURCHASE_THE_ITEM = 'PURCHASE_USER_INELIGIBLE_TO_PURCHASE_THE_ITEM',
  PURCHASE_USER_PAYMENT_DECLINED_DUE_TO_INSUFFICIENT_FUNDS = 'PURCHASE_USER_PAYMENT_DECLINED_DUE_TO_INSUFFICIENT_FUNDS',
  PURCHASE_VOUCHER_CODE_NOT_FOUND = 'PURCHASE_VOUCHER_CODE_NOT_FOUND',
  PURCHASE_VOUCHER_EXPIRED = 'PURCHASE_VOUCHER_EXPIRED',
  PURCHASE_VOUCHER_INCOMPATIBLE_PLAN = 'PURCHASE_VOUCHER_INCOMPATIBLE_PLAN',
  PURCHASE_VOUCHER_ALREADY_USED = 'PURCHASE_VOUCHER_ALREADY_USED',
  PURCHASE_VOUCHER_MAX_NUMBER_OF_USES = 'PURCHASE_VOUCHER_MAX_NUMBER_OF_USES',

  // Category: Purchase - Plan change (03)
  PURCHASE_PLAN_CHANGE_UNKNOWN = 'PURCHASE_PLAN_CHANGE_UNKNOWN',
  PURCHASE_PLAN_CHANGE_ITEM_NOT_FOUND = 'PURCHASE_PLAN_CHANGE_ITEM_NOT_FOUND',
  PURCHASE_PLAN_CHANGE_ITEM_LIST_UNAVAILABLE = 'PURCHASE_PLAN_CHANGE_ITEM_LIST_UNAVAILABLE',
  PURCHASE_PLAN_CHANGE_EXISTING_GIFT = 'PURCHASE_PLAN_CHANGE_EXISTING_GIFT',
  PURCHASE_PLAN_CHANGE_EXISTING_MOVE = 'PURCHASE_PLAN_CHANGE_EXISTING_MOVE',
  PURCHASE_PLAN_CHANGE_INVALID_DIRECTION = 'PURCHASE_PLAN_CHANGE_INVALID_DIRECTION',
  PURCHASE_PLAN_CHANGE_UNSUPPORTED_PRODUCT_TYPE = 'PURCHASE_PLAN_CHANGE_UNSUPPORTED_PRODUCT_TYPE',

  // Category: Purchase - Restore Purchases (04)
  PURCHASE_RESTORE_PURCHASE_IAP_PLUGIN_UNAVAILABLE = 'PURCHASE_RESTORE_PURCHASE_IAP_PLUGIN_UNAVAILABLE',

  // Category: Playback - General (05)
  PLAYBACK_GENERAL_UNKNOWN = 'PLAYBACK_GENERAL_UNKNOWN',
  PLAYBACK_GENERAL_NETWORK_ERROR = 'PLAYBACK_GENERAL_NETWORK_ERROR',
  PLAYBACK_GENERAL_VIDEO_NOT_FOUND = 'PLAYBACK_GENERAL_VIDEO_NOT_FOUND',
  PLAYBACK_GENERAL_UNSUPPORTED_FORMAT = 'PLAYBACK_GENERAL_UNSUPPORTED_FORMAT',
  PLAYBACK_GENERAL_INSUFFICIENT_BANDWIDTH = 'PLAYBACK_GENERAL_INSUFFICIENT_BANDWIDTH',
  PLAYBACK_GENERAL_BUFFERING_TIMEOUT = 'PLAYBACK_GENERAL_BUFFERING_TIMEOUT',
  PLAYBACK_GENERAL_DECODING_ERROR = 'PLAYBACK_GENERAL_DECODING_ERROR',
  PLAYBACK_GENERAL_DEVICE_NOT_SUPPORTED = 'PLAYBACK_GENERAL_DEVICE_NOT_SUPPORTED',
  PLAYBACK_GENERAL_DRM_ERROR = 'PLAYBACK_GENERAL_DRM_ERROR',
  PLAYBACK_GENERAL_MEDIA_SOURCE_ERROR = 'PLAYBACK_GENERAL_MEDIA_SOURCE_ERROR',
  PLAYBACK_GENERAL_MEDIA_KEY_SYSTEM_ERROR = 'PLAYBACK_GENERAL_MEDIA_KEY_SYSTEM_ERROR',
  PLAYBACK_GENERAL_MEDIA_KEY_SESSION_ERROR = 'PLAYBACK_GENERAL_MEDIA_KEY_SESSION_ERROR',
  PLAYBACK_GENERAL_MEDIA_METADATA_ERROR = 'PLAYBACK_GENERAL_MEDIA_METADATA_ERROR',
  PLAYBACK_GENERAL_SOURCE_BUFFER_ERROR = 'PLAYBACK_GENERAL_SOURCE_BUFFER_ERROR',
  PLAYBACK_GENERAL_MEDIA_INFO_ERROR = 'PLAYBACK_GENERAL_MEDIA_INFO_ERROR',
  PLAYBACK_GENERAL_MEDIA_TIMEOUT = 'PLAYBACK_GENERAL_MEDIA_TIMEOUT',
  PLAYBACK_GENERAL_NETWORK_TIMEOUT = 'PLAYBACK_GENERAL_NETWORK_TIMEOUT',
  PLAYBACK_GENERAL_ENCRYPTION_ERROR = 'PLAYBACK_GENERAL_ENCRYPTION_ERROR',
  PLAYBACK_GENERAL_FRAGMENT_LOAD_ERROR = 'PLAYBACK_GENERAL_FRAGMENT_LOAD_ERROR',
  PLAYBACK_GENERAL_FRAGMENT_DECRYPT_ERROR = 'PLAYBACK_GENERAL_FRAGMENT_DECRYPT_ERROR',
  PLAYBACK_GENERAL_LICENSE_REQUEST_FAILED = 'PLAYBACK_GENERAL_LICENSE_REQUEST_FAILED',
  PLAYBACK_GENERAL_SEGMENT_PARSE_ERROR = 'PLAYBACK_GENERAL_SEGMENT_PARSE_ERROR',
  PLAYBACK_GENERAL_SEGMENT_MISSING = 'PLAYBACK_GENERAL_SEGMENT_MISSING',
  PLAYBACK_GENERAL_LEVEL_SWITCH_ERROR = 'PLAYBACK_GENERAL_LEVEL_SWITCH_ERROR',
  PLAYBACK_GENERAL_MANIFEST_LOAD_ERROR = 'PLAYBACK_GENERAL_MANIFEST_LOAD_ERROR',
  PLAYBACK_GENERAL_MSE_ERROR = 'PLAYBACK_GENERAL_MSE_ERROR',
  PLAYBACK_GENERAL_AUDIO_CODEC_ERROR = 'PLAYBACK_GENERAL_AUDIO_CODEC_ERROR',
  PLAYBACK_GENERAL_DRM_INVALID_LICENSE = 'PLAYBACK_GENERAL_DRM_INVALID_LICENSE',
  PLAYBACK_GENERAL_SEEK_FAILED = 'PLAYBACK_GENERAL_SEEK_FAILED',
  PLAYBACK_GENERAL_PLAYBACK_POSITION_OUT_OF_BOUNDS = 'PLAYBACK_GENERAL_PLAYBACK_POSITION_OUT_OF_BOUNDS',
  PLAYBACK_GENERAL_PLAYBACK_TIMEOUT = 'PLAYBACK_GENERAL_PLAYBACK_TIMEOUT',
  PLAYBACK_GENERAL_UNSUPPORTED_DRM_SCHEME = 'PLAYBACK_GENERAL_UNSUPPORTED_DRM_SCHEME',
  PLAYBACK_GENERAL_BUFFERING_ERROR = 'PLAYBACK_GENERAL_BUFFERING_ERROR',
  PLAYBACK_GENERAL_FRAGMENT_TIMEOUT = 'PLAYBACK_GENERAL_FRAGMENT_TIMEOUT',
  PLAYBACK_GENERAL_PLAYER_NOT_CONFIGURED = 'PLAYBACK_GENERAL_PLAYER_NOT_CONFIGURED',
  PLAYBACK_GENERAL_PLAYER_NOT_LOADED = 'PLAYBACK_GENERAL_PLAYER_NOT_LOADED',
  PLAYBACK_CONCURRENCY_ERROR = 'PLAYBACK_CONCURRENCY_ERROR',
  PLAYBACK_GEO_RESTRICTION_ERROR = 'PLAYBACK_GEO_RESTRICTION_ERROR',
  PLAYBACK_CURRENTLY_NOT_AVAILABLE = 'PLAYBACK_CURRENTLY_NOT_AVAILABLE',

  // Category: Entitlements - General (06)
  ENTITLEMENT_GENERAL_UNKNOWN = 'ENTITLEMENT_GENERAL_UNKNOWN',
  ENTITLEMENT_PROFILE_ERROR = 'ENTITLEMENT_PROFILE_ERROR',

  // Category: Configuration - General (07)
  CONFIGURATION_GENERAL_UNKNOWN = 'CONFIGURATION_GENERAL_UNKNOWN',
  CONFIGURATION_GENERAL_MISSING_PAGE = 'CONFIGURATION_GENERAL_MISSING_PAGE',
  CONFIGURATION_GENERAL_MISSING_PAGE_TEMPLATE = 'CONFIGURATION_GENERAL_MISSING_PAGE_TEMPLATE',

  // Category: Gifts - General (08)
  GIFT_GENERAL_UNKNOWN = 'GIFT_GENERAL_UNKNOWN',
  GIFT_GENERAL_NO_GIFTS_AVAILABLE_TO_PURCHASE = 'GIFT_GENERAL_NO_GIFTS_AVAILABLE_TO_PURCHASE',
  GIFT_GENERAL_MAX_NUMBER_OF_USES = 'GIFT_GENERAL_MAX_NUMBER_OF_USES',

  // Category: EPG - General (09)
  EPG_GENERAL_UNKNOWN = 'EPG_GENERAL_UNKNOWN',
  EPG_GENERAL_NO_CONTENT = 'EPG_GENERAL_NO_CONTENT',

  // Category: Web integration - General (10)
  WEB_INTEGRATION_GENERAL_UNKNOWN = 'WEB_INTEGRATION_GENERAL_UNKNOWN',
  WEB_INTEGRATION_GENERAL_OPERATION_NOT_SUPPORTED = 'WEB_INTEGRATION_GENERAL_OPERATION_NOT_SUPPORTED',
}

export const errorToCode: Record<Errors, string> = {
  // Category: Unknown
  UNKNOWN: 'UNK_01_00', // An unknown error occurred.

  // Category: Purchase - Offers Loading (01)
  PURCHASE_OFFERS_LOADING_UNKNOWN: 'IAP_01_00', // An unknown error occurred during offers loading.
  PURCHASE_OFFERS_LOADING_IAP_CONFIG_UNAVAILABLE: 'IAP_01_01', // IAP config is unavailable during offers loading.
  PURCHASE_OFFERS_LOADING_IAP_PLUGIN_UNAVAILABLE: 'IAP_01_02', // IAP plugin is unavailable during offers loading.
  PURCHASE_OFFERS_LOADING_USER_NOT_LOGGED_IN: 'IAP_01_03', // User is not logged in during offers loading.
  PURCHASE_OFFERS_LOADING_PRODUCT_CATALOG_UNAVAILABLE: 'IAP_01_04', // Product catalog is unavailable during offers loading.
  PURCHASE_OFFERS_LOADING_PROFILE_ENTITLEMENTS_UNAVAILABLE: 'IAP_01_05', // Profile entitlements are unavailable during offers loading.
  PURCHASE_OFFERS_LOADING_UNKNOWN_EXISTING_SUBSCRIPTION: 'IAP_01_06', // Unknown existing subscription during offers loading.
  PURCHASE_OFFERS_LOADING_SKU_UNAVAILABLE: 'IAP_01_07', // SKU arrived from core but is unavailable on store during offers loading.
  PURCHASE_OFFERS_LOADING_ENTITLEMENT_MISSING_AND_DEVICE_RESTRICTED:
    'IAP_01_08', // This content requires an entitlement that the user does not have, and may not acquire it on this device.
  PURCHASE_OFFERS_LOADING_CREDIT_CARD_EXISTING_SUBSCRIPTION: 'IAP_01_09', // Web existing subscription during offers loading.
  PURCHASE_OFFERS_LOADING_IAP_AMAZON_EXISTING_SUBSCRIPTION: 'IAP_01_10', // Amazon existing subscription during offers loading.
  PURCHASE_OFFERS_LOADING_IAP_APPLE_EXISTING_SUBSCRIPTION: 'IAP_01_11', // Apple existing subscription during offers loading.
  PURCHASE_OFFERS_LOADING_IAP_GOOGLE_EXISTING_SUBSCRIPTION: 'IAP_01_12', // Google existing subscription during offers loading.
  PURCHASE_OFFERS_LOADING_IAP_ROKU_EXISTING_SUBSCRIPTION: 'IAP_01_13', // Roku existing subscription during offers loading.
  PURCHASE_OFFERS_LOADING_PAYPAL_EXISTING_SUBSCRIPTION: 'IAP_01_14', // Web existing subscription during offers loading.
  PURCHASE_OFFERS_LOADING_NO_OFFERS_TO_PURCHASE: 'IAP_01_15', // User is trying purchase something but there is nothing to purchase.
  PURCHASE_OFFERS_LOADING_IAP_VIZIO_EXISTING_SUBSCRIPTION: 'IAP_01_16', // Vizio existing subscription during offers loading

  // Category: Purchase - Validation (02)
  PURCHASE_VALIDATION_UNKNOWN: 'IAP_02_00', // An unknown error occurred during purchase.
  PURCHASE_VALIDATION_IAP_PLUGIN_UNAVAILABLE: 'IAP_02_01', // IAP plugin is unavailable during purchase.
  PURCHASE_VALIDATION_STORE_ISSUE: 'IAP_02_02', // Store issue occurred during purchase.
  PURCHASE_VALIDATION_UNKNOWN_EXISTING_SUBSCRIPTION: 'IAP_02_03', // Unknown existing subscription during purchase.
  PURCHASE_VALIDATION_ALREADY_IN_PROGRESS: 'IAP_02_04', // A purchase is already in progress.
  PURCHASE_VALIDATION_STORE_ITEM_UNAVAILABLE: 'IAP_02_05', // Store item is unavailable during purchase.
  PURCHASE_VALIDATION_RECEIPT_UNAVAILABLE: 'IAP_02_06', // Receipt is unavailable during purchase.
  PURCHASE_VALIDATION_SKU_UNAVAILABLE: 'IAP_02_07', // SKU is unavailable during purchase.
  PURCHASE_VALIDATION_ITEM_NOT_OWNED: 'IAP_02_08', // Item is not owned during purchase.
  PURCHASE_VALIDATION_ITEM_ALREADY_OWNED: 'IAP_02_09', // Item is already owned during purchase.
  PURCHASE_VALIDATION_USER_CANCELED: 'IAP_02_10', // User canceled the purchase.
  PURCHASE_VALIDATION_BILLING_CLIENT_NOT_READY: 'IAP_02_11', // Billing client is not ready during purchase.
  PURCHASE_VALIDATION_FAILED: 'IAP_02_12', // Purchase validation failed.
  PURCHASE_VALIDATION_USER_NOT_LOGGED_IN: 'IAP_02_13', // User is not logged in during purchase.
  PURCHASE_VALIDATION_PROFILE_ENTITLEMENTS_UNAVAILABLE: 'IAP_02_14', // Profile entitlements are unavailable during purchase.
  PURCHASE_UNKNOWN_EXISTING_SUBSCRIPTION: 'IAP_02_15', // Unknown existing subscription during purchase.
  PURCHASE_VALIDATION_CONFLICT: 'IAP_02_16', // The purchase failed to be associated with the user account. This issue occurs when a 409 conflict error is encountered during purchase validation.
  PURCHASE_VALIDATION_SERVER_FAILURE: 'IAP_02_17', // The purchase failed to get validated and attached to the user account and the error is likely temporary or due to a misconfiguration or transient issue on the server side. This issue occurs when a 5xx client error is encountered during purchase validation.
  PURCHASE_NETWORK_ERROR: 'IAP_02_18', // A network error occurred during the operation with the device's payment service.
  PURCHASE_SERVICE_UNAVAILABLE: 'IAP_02_19', // The payment service is currently unavailable on the device.
  PURCHASE_BILLING_UNAVAILABLE: 'IAP_02_20', // A user related billing error occurred during processing. Possible causes include an outdated App Store app, unsupported country, enterprise account restrictions, or payment method issues.
  PURCHASE_FEATURE_NOT_SUPPORTED: 'IAP_02_21', // The requested feature is not supported by the App Store on the current device.
  PURCHASE_OPERATION_NOT_SUPPORTED: 'IAP_02_22', // The requested purchase operation (upgrade, downgrade, crossgrade) is not supported by the platform on the current device.
  PURCHASE_PAYPAL_USER_CANCELED: 'IAP_02_23', // User canceled the PayPal purchase.
  PURCHASE_PAYPAL_UNKNOWN: 'IAP_02_24', // An unknown error occurred during PayPal purchase.
  PURCHASE_USER_INELIGIBLE_TO_PURCHASE_THE_ITEM: 'IAP_02_25', // Device user does not currently meet the offer eligibility requirements.
  PURCHASE_USER_PAYMENT_DECLINED_DUE_TO_INSUFFICIENT_FUNDS: 'IAP_02_26', // The payment was declined due to insufficient funds.
  PURCHASE_VOUCHER_CODE_NOT_FOUND: 'IAP_02_27', // The promo code entered during purchase is invalid or does not exist.
  PURCHASE_VOUCHER_EXPIRED: 'IAP_02_28', // The promo code entered during purchase is expired.
  PURCHASE_VOUCHER_INCOMPATIBLE_PLAN: 'IAP_02_29', // The promo code entered during purchase does not apply to the selected plan.
  PURCHASE_VOUCHER_ALREADY_USED: 'IAP_02_30', // The promo code entered during purchase has already been used with this account.
  PURCHASE_VOUCHER_MAX_NUMBER_OF_USES: 'IAP_02_31', // The promo code entered during purchase has reached its maximum number of uses (already used by another account).

  // Category: Purchase - Plan change (03)
  PURCHASE_PLAN_CHANGE_UNKNOWN: 'IAP_03_00', // An unknown error occurred during purchase update.
  PURCHASE_PLAN_CHANGE_ITEM_NOT_FOUND: 'IAP_03_01', // Item not found in purchases list during purchase update.
  PURCHASE_PLAN_CHANGE_ITEM_LIST_UNAVAILABLE: 'IAP_03_02', // Item list is unavailable during purchase update.
  PURCHASE_PLAN_CHANGE_EXISTING_GIFT: 'IAP_03_03', // Integration doesn't allow changing subscription with active gift.
  PURCHASE_PLAN_CHANGE_EXISTING_MOVE: 'IAP_03_04', // Integration doesn't allow changing subscription with active move.
  PURCHASE_PLAN_CHANGE_INVALID_DIRECTION: 'IAP_03_05', // Integration doesn't allow changing subscription with non existing or invalid direction (e.g. purchase).
  PURCHASE_PLAN_CHANGE_UNSUPPORTED_PRODUCT_TYPE: 'IAP_03_06', // Integration doesn't allow changing a subscription to unsupported product type (e.g. consumable, entitlements).

  // Category: Purchase - Restore Purchases (04)
  PURCHASE_RESTORE_PURCHASE_IAP_PLUGIN_UNAVAILABLE: 'IAP_04_01', // IAP plugin is unavailable during restore purchase.

  // Category: Playback - General (05)
  PLAYBACK_GENERAL_UNKNOWN: 'PLB_05_00', // An unknown error occurred during video playback.
  PLAYBACK_GENERAL_NETWORK_ERROR: 'PLB_05_01', // A network error occurred during video playback.
  PLAYBACK_GENERAL_VIDEO_NOT_FOUND: 'PLB_05_02', // The video was not found during playback.
  PLAYBACK_GENERAL_UNSUPPORTED_FORMAT: 'PLB_05_03', // The video format is unsupported during playback.
  PLAYBACK_GENERAL_INSUFFICIENT_BANDWIDTH: 'PLB_05_04', // Insufficient bandwidth during video playback.
  PLAYBACK_GENERAL_BUFFERING_TIMEOUT: 'PLB_05_05', // Buffering timeout occurred during video playback.
  PLAYBACK_GENERAL_DECODING_ERROR: 'PLB_05_06', // A decoding error occurred during video playback.
  PLAYBACK_GENERAL_DEVICE_NOT_SUPPORTED: 'PLB_05_07', // The playback device is not supported.
  PLAYBACK_GENERAL_DRM_ERROR: 'PLB_05_08', // A DRM error occurred during video playback.
  PLAYBACK_GENERAL_MEDIA_SOURCE_ERROR: 'PLB_05_09', // A media source error occurred during video playback.
  PLAYBACK_GENERAL_MEDIA_KEY_SYSTEM_ERROR: 'PLB_05_10', // An error occurred with the media key system.
  PLAYBACK_GENERAL_MEDIA_KEY_SESSION_ERROR: 'PLB_05_11', // An error occurred with the media key session.
  PLAYBACK_GENERAL_MEDIA_METADATA_ERROR: 'PLB_05_12', // An error occurred while retrieving media metadata.
  PLAYBACK_GENERAL_SOURCE_BUFFER_ERROR: 'PLB_05_13', // An error occurred with the source buffer during playback.
  PLAYBACK_GENERAL_MEDIA_INFO_ERROR: 'PLB_05_14', // An error occurred retrieving media info.
  PLAYBACK_GENERAL_MEDIA_TIMEOUT: 'PLB_05_15', // A timeout occurred during media loading.
  PLAYBACK_GENERAL_NETWORK_TIMEOUT: 'PLB_05_16', // A network timeout occurred during video playback.
  PLAYBACK_GENERAL_ENCRYPTION_ERROR: 'PLB_05_17', // An encryption error occurred during video playback.
  PLAYBACK_GENERAL_FRAGMENT_LOAD_ERROR: 'PLB_05_18', // Failed to load a media fragment (usually a .ts file for HLS).
  PLAYBACK_GENERAL_FRAGMENT_DECRYPT_ERROR: 'PLB_05_19', // Failed to decrypt the media fragment due to DRM or encryption issues.
  PLAYBACK_GENERAL_LICENSE_REQUEST_FAILED: 'PLB_05_20', // Failed to request or acquire a DRM license for encrypted content.
  PLAYBACK_GENERAL_SEGMENT_PARSE_ERROR: 'PLB_05_22', // Error occurred while parsing a media segment for playback.
  PLAYBACK_GENERAL_SEGMENT_MISSING: 'PLB_05_23', // A required media segment is missing or unavailable for playback.
  PLAYBACK_GENERAL_LEVEL_SWITCH_ERROR: 'PLB_05_24', // An error occurred while switching between different quality levels.
  PLAYBACK_GENERAL_MANIFEST_LOAD_ERROR: 'PLB_05_25', // Error code returned when loading the manifest failed.
  PLAYBACK_GENERAL_MSE_ERROR: 'PLB_05_26', // A general Media Source Extensions (MSE) error occurred.
  PLAYBACK_GENERAL_AUDIO_CODEC_ERROR: 'PLB_05_27', // An audio codec error occurred during playback.
  PLAYBACK_GENERAL_DRM_INVALID_LICENSE: 'PLB_05_28', // The DRM license provided is invalid or expired.
  PLAYBACK_GENERAL_SEEK_FAILED: 'PLB_05_29', // Seeking to the specified position failed.
  PLAYBACK_GENERAL_PLAYBACK_POSITION_OUT_OF_BOUNDS: 'PLB_05_30', // Playback was attempted at a time that is outside the valid range of the media content.
  PLAYBACK_GENERAL_PLAYBACK_TIMEOUT: 'PLB_05_31', // Playback did not start within the expected time.
  PLAYBACK_GENERAL_UNSUPPORTED_DRM_SCHEME: 'PLB_05_32', // The DRM protection scheme in use is not supported by the player or device.
  PLAYBACK_GENERAL_BUFFERING_ERROR: 'PLB_05_33', // An error occurred while buffering media.
  PLAYBACK_GENERAL_FRAGMENT_TIMEOUT: 'PLB_05_34', // Timeout occurred while loading a media fragment.
  PLAYBACK_GENERAL_PLAYER_NOT_CONFIGURED: 'PLB_05_36', // No player is configured for this service.
  PLAYBACK_GENERAL_PLAYER_NOT_LOADED: 'PLB_05_37', // An error occurred while trying to load the configured player.
  PLAYBACK_CONCURRENCY_ERROR: 'PLB_05_38', // The user have reached the limit for simultaneous number of devices that can stream videos.
  PLAYBACK_GEO_RESTRICTION_ERROR: 'PLB_05_39', // The playback is blocked due to geo restriction.
  PLAYBACK_CURRENTLY_NOT_AVAILABLE: 'PLB_05_40', // Playback is restricted for some objects when outside the defined availability window. See content listings for details.

  // Category: Entitlements - General (06)
  ENTITLEMENT_GENERAL_UNKNOWN: 'ENT_06_00', // An unknown error occurred due to entitlements.
  ENTITLEMENT_PROFILE_ERROR: 'ENT_06_01', // There was a problem retrieving account entitlements.

  // Category: Configuration - General (07)
  CONFIGURATION_GENERAL_UNKNOWN: 'CON_07_00', // An unknown error occurred due to configuration.
  CONFIGURATION_GENERAL_MISSING_PAGE: 'CON_07_01', // The requested page has not been configured.
  CONFIGURATION_GENERAL_MISSING_PAGE_TEMPLATE: 'CON_07_02', // The requested page template has not been configured.

  // Category: Gifts - General (08)
  GIFT_GENERAL_UNKNOWN: 'GFT_08_00', // An unknown error occurred due to gifts.
  GIFT_GENERAL_NO_GIFTS_AVAILABLE_TO_PURCHASE: 'GFT_08_01', // There are no gifts available to purchase.
  GIFT_GENERAL_MAX_NUMBER_OF_USES: 'GFT_08_02', // The maximum number of uses for the gift code has been reached.

  // Category: EPG - General (09)
  EPG_GENERAL_UNKNOWN: 'EPG_09_00', // An unknown error occurred within the EPG.
  EPG_GENERAL_NO_CONTENT: 'EPG_09_01', // No content was found or configured for the EPG.

  // Category: Web integration - General (10)
  WEB_INTEGRATION_GENERAL_UNKNOWN: 'WBI_10_00', // An unknown error occurred within the web integration.
  WEB_INTEGRATION_GENERAL_OPERATION_NOT_SUPPORTED: 'WBI_10_01', // Web integration operation is not supported or implemented.
};

// A list of fatal errors that are considered fatal or irrecoverable.
export const fatalErrors: Errors[] = [
  Errors.PLAYBACK_GENERAL_UNKNOWN,
  Errors.PLAYBACK_GENERAL_MEDIA_SOURCE_ERROR,
  Errors.PLAYBACK_GENERAL_NETWORK_ERROR,
];

enum ErrorCategory {
  unk = 'unk',
  iap = 'iap',
  plb = 'plb',
  ent = 'ent',
  con = 'con',
  gft = 'gft',
  epg = 'epg',
  wbi = 'wbi',
}

export const isErrorCategory = (category: string): category is ErrorCategory =>
  Object.values(ErrorCategory).includes(category);

export const errorCategoryToIcon: Record<ErrorCategory, IconNames | null> = {
  [ErrorCategory.unk]: 'generic_error',
  [ErrorCategory.iap]: 'generic_error',
  [ErrorCategory.ent]: 'generic_error',
  [ErrorCategory.plb]: null,
  [ErrorCategory.con]: 'configuration_error',
  [ErrorCategory.gft]: 'generic_error',
  [ErrorCategory.epg]: 'generic_error',
  [ErrorCategory.wbi]: 'generic_error',
};
